export const states = {
  0: "Nicht erledigt",
  1: "Erledigt",
  2: "Abgelehnt",
  3: "Delegiert",
  4: "Archiviert",
};
